// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useRef, useState } from 'react';
/* eslint-disable-next-line import/no-unresolved */
/* eslint-disable no-return-assign */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import { CSVLink } from 'react-csv';
import { isObjectEmpty } from '../../infrastructure/utils/common';

const CSVLinkButton = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  data,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  filterData,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  label = 'Download CSV',
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  style = {},
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  loadData,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  className,
}) => {
  const csvLinkRef = useRef([]);
  const [loading, setLoading] = useState(false);

  const onClick = () => {
    if (loadData) {
      setLoading(true);
      loadData().then(() => {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        csvLinkRef.current.forEach(ref => ref.link.click());
      });
      setLoading(false);
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      csvLinkRef.current.forEach(ref => ref.link.click());
    }
  };

  return (
    <span
      title={isObjectEmpty(filterData) ? 'Filter is required' : ''}
      className={className}
    >
      <button
        type='button'
        className={`btn btn-primary csv-link-button ${
          isObjectEmpty(filterData) || loading ? 'noHover' : ''
        }`}
        style={style}
        onClick={onClick}
      >
        {loading ? (
          <>
            <i className='fa fa-spinner fa-spin' /> Loading
          </>
        ) : (
          label
        )}
      </button>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {data.map(({ id, items, headers, fileName }, i) => (
        <CSVLink
          key={id}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ref={el => (csvLinkRef.current[i] = el)}
          headers={headers}
          data={items}
          filename={fileName}
          target='_blank'
        />
      ))}
    </span>
  );
};

export default React.memo(CSVLinkButton);
